import React from 'react';
import { Typography } from '@mui/material';
import type { HeadingBlock } from '../../../types/backend';

interface Props {
  block: HeadingBlock;
}

const HeadingBlockView: React.FC<Props> = ({ block }) => (
  <Typography
    variant="subtitle2"
    component="h4"
    sx={{ mt: 2, mb: 0.5, color: 'text.primary', fontWeight: 700 }}
  >
    {block.text}
  </Typography>
);

export default HeadingBlockView;
